import { render, staticRenderFns } from "./NewLoan.vue?vue&type=template&id=98901990&"
import script from "./NewLoan.vue?vue&type=script&lang=js&"
export * from "./NewLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports